// src/components/ui/HexIcon.jsx
// Hexagon-framed icon with optional glow

import React from 'react';

const HexIcon = ({ children, size = 64, glowing = false, className = '' }) => {
  return (
    <div
      className={`relative flex items-center justify-center ${glowing ? 'hex-glow' : ''} ${className}`}
      style={{ width: size, height: size }}
    >
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full">
        <polygon
          points="50,2 95,25 95,75 50,98 5,75 5,25"
          fill="rgba(13, 148, 136, 0.1)"
          stroke="rgba(45, 212, 191, 0.4)"
          strokeWidth="2"
        />
      </svg>
      <div className="relative z-10 text-teal-400">{children}</div>
    </div>
  );
};

export default HexIcon;